import { isString, isRegExp, filter } from 'lodash';

export enum Strategies {
  cacheFirst = 'CacheFirst',
  cacheOnly = 'CacheOnly',
  networkFirst = 'NetworkFirst',
  networkOnly = 'NetworkOnly',
  staleWhileRevalidate = 'StaleWhileRevalidate',
  clearCache = 'ClearCache',
}

export const isServiceWorkerSupported = (): boolean => 'serviceWorker' in navigator;

export const removeCache = (expression: string | RegExp): Promise<boolean | boolean[]> | undefined => {
  if (!isServiceWorkerSupported()) {
    return;
  }

  if (isString(expression)) {
    return caches.delete(expression);
  }

  if (isRegExp(expression)) {
    return caches
      .keys()
      .then(keys => filter(keys, key => expression.test(key)))
      .then(keys => Promise.all(keys.map(cacheToDelete => caches.delete(cacheToDelete))));
  }
};
